import { createWebHistory, createRouter } from "vue-router";
import store from "../store";
// Auth
import LoginPage from "../views/Auth/LoginPage";

// Member
import MemberList from "../views/Member/List";

// Transaction
import TransactionPage from "../views/Transaction/Page";
import TransactionList from "../views/Transaction/List";

// Race
import RaceHistory from "../views/Race/History";

// Calc
import PeriodCalcList from "../views/Calc/PeriodCalcList";

const routes = [
  // Auth
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  // Member
  {
    path: "/Member/List",
    name: "MemberList",
    component: MemberList,
    meta: {
      authRequired: true,
    },
  },
  // Transaction
  {
    path: "/Transaction/",
    component: TransactionPage,
    name: "TransactionPage",
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "List",
        name: "TransactionList",
        component: TransactionList,
      },
    ],
  },
  // Race
  {
    path: "/Race/History",
    name: "RaceHistory",
    component: RaceHistory,
    meta: {
      authRequired: true,
    },
  },
  // Calc
  {
    path: "/Calc/Period",
    component: PeriodCalcList,
    name: "PeriodCalcList",
    meta: {
      authRequired: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;

  if (to.meta.authRequired) {
    // 인증이 필요한 페이지일 경우 인증 체크
    if (isAuthenticated) {
      return next(); // 페이지 전환
    } else {
      return next("/");
    }
  } else {
    next(); // 페이지 전환
  }
});

export default router;
